"use client";

import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What exactly is the AI Assessment?",
  answer: "It is a comprehensive, personalized report that audits your current business operations to identify specific areas where AI can automate tasks. We pinpoint exactly where you are losing hours and provide a roadmap to reclaim them."
}, {
  question: "How long does the process take?",
  answer: "The entire process requires only 15-20 minutes of your time for a call with Olivia, our AI voice agent. Once the call is complete, our team of consultants and AI models generate your full report within 48 hours."
}, {
  question: "Who is Olivia, and why a voice agent?",
  answer: "Olivia is our proprietary AI voice agent designed to conduct high-level consulting interviews. Using an AI agent allows us to gather data with zero scheduling friction, ensuring we can start your assessment immediately."
}, {
  question: "Is this suitable for my business size?",
  answer: "Our assessment is specifically engineered for small to medium businesses with 5 to 50 employees. This is the 'sweet spot' where operational inefficiencies are most costly but also easiest to solve with targeted AI implementation."
}, {
  question: "How do we price our assessments?",
  answer: "Pricing is customized based on your business needs and scope of assessment. We'll discuss investment and ROI expectations directly during your consultation. Contact us to learn more."
}];
export default function FrequentlyAskedQuestions() {
  return <section data-section-id="229714" id="frequently-asked-questions" className="bg-background text-foreground py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <h2 className="font-default text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Everything You're Wondering
          </h2>
          <p className="mt-4 font-sans text-lg text-muted-foreground">
            Clear answers regarding our AI Assessment process and how we find your hidden hours. Contact us for pricing details.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="group border-b border-[#1F1F1F] px-2 transition-colors duration-300 last:border-b-0 data-[state=open]:bg-accent/5 sm:px-4">
              <AccordionTrigger className="py-6 hover:no-underline [&>svg:last-child]:hidden">
                <div className="flex w-full items-center justify-between gap-4 text-left">
                  <span className="font-default text-base font-semibold text-foreground">
                    {faq.question}
                  </span>
                  <Plus className="size-5 shrink-0 text-[#2D6A4F] transition-transform duration-300 group-data-[state=open]:rotate-45" />
                </div>
              </AccordionTrigger>
              <AccordionContent className="pb-6 pt-0 font-sans text-base leading-relaxed text-[#A1A1AA]">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}